import {
  ActionConfig,
  ActionConfigMap,
  ActionParameter,
} from "../types/ActionConfig";
import actionParamsJson from "../config/action_params.json";

// JSONデータをActionConfigMapに変換
export const actionConfigMap: ActionConfigMap = actionParamsJson.reduce(
  (acc, config) => {
    acc[config.action] = config as ActionConfig;
    return acc;
  },
  {} as ActionConfigMap
);

// 利用可能なアクションのリストを取得
export const getAvailableActions = (): string[] => {
  return Object.keys(actionConfigMap);
};

// 特定のアクションの設定を取得
export const getActionConfig = (action: string): ActionConfig | undefined => {
  return actionConfigMap[action];
};

// アクションのパラメータを取得
export const getActionParameters = (action: string): ActionParameter[] => {
  const config = actionConfigMap[action];
  return config ? config.parameters : [];
};

// test_target型のパラメータを持つかチェック
export const hasTestTargetParameter = (action: string): boolean => {
  const params = getActionParameters(action);
  return params.some((p) => p.type === "test_target");
};

export const get_test_target_parameter_counts = (
  action: string
): { required_count: number; total_count: number } => {
  const params = getActionParameters(action);
  return params.reduce(
    (acc, param) => {
      if (param.type !== "test_target") {
        return acc;
      }
      const required_count = param.required ? acc.required_count + 1 : acc.required_count;
      return {
        required_count,
        total_count: acc.total_count + 1,
      };
    },
    { required_count: 0, total_count: 0 }
  );
};

// 必須パラメータを取得
export const getRequiredParameters = (action: string): ActionParameter[] => {
  const params = getActionParameters(action);
  return params.filter((p) => p.required === true);
};

// アクションの必須パラメータが全て入力されているかチェック
export const validateRequiredParameters = (
  action: string,
  parameters: { key: string; value: string }[]
): { isValid: boolean; missingParams: string[] } => {
  const requiredParams = getRequiredParameters(action);
  const missingParams: string[] = [];

  requiredParams.forEach((param) => {
    const paramValue = parameters.find((p) => p.key === param.name)?.value;
    if (!paramValue || paramValue.trim() === "") {
      missingParams.push(param.name);
    }
  });

  return {
    isValid: missingParams.length === 0,
    missingParams,
  };
};
